import React, { Component } from 'react';
import { connect } from 'react-redux';
import LOOKUP from 'constants/lookup';
import util from 'library/util';
import { selectDiscountModel } from 'selectors/entitySelector';
import { formError, clearFormErrors, formInput, initializeCustomizedDiscountForm } from 'actions/FormActions';
import { showSnackbar, showError } from 'actions/CommonActions';
import { getCustomizedDiscount, saveCustomizedDiscount } from 'actions/EntityActions';
import { discountEditCrumb } from 'utils/breadcrumbInfo';
import WithRouter from 'custom/withRouter';
// Basic Components
import Button from 'screens/components/basic/Button';
import CardSimple from 'screens/components/basic/CardSimple';
import ToggleInput from 'screens/components/basic/ToggleInput';
import TextInput from 'screens/components/basic/TextInput';
import DecimalInput from 'screens/components/basic/DecimalInput';
import Grid from 'screens/components/basic/Grid';
import CheckInput from 'screens/components/basic/CheckInput';
import PageHeader from 'screens/components/basic/PageHeader';
import PageBottomWithButtons from 'screens/components/basic/PageBottomWithButtons';

class DiscountSave extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            status: '',
            activePage: 1,
            itemsPerPage: 25,
            dialogProducts: false,
            errorSelectedCategories: false,
            errorNoAddedItems: false,
            products: [],
            orderBy: "ASC",
            sortBy: "Id"
        };
    }

    componentWillMount = () => {
        const discountId = this.props.params.id;
        if (discountId) {
            this.setState({ status: "EDIT" });
            this.props.getCustomizedDiscount(discountId, this.props.branchId);
        } else {
            this.setState({ status: "ADD" });
            this.props.init(this.props.name);
        }
    }

    componentWillUnmount = () => {
        this.props.init(this.props.name);
        this.props.clearFormErrors();
        this.props.formInput(``, `discountSavePromotionCode`);
        this.props.formInput(0, `discountSaveMinimumAmountToApplyPromotionCode`);
    }

    componentWillReceiveProps = (newProps) => {
        if (newProps.saveTimeStamp && this.props.saveTimeStamp !== newProps.saveTimeStamp) {
            if (newProps.saveSuccess === true)
                this.saveSuccess();
            else
                this.saveFailure(newProps.saveError);
        }

        if ((this.props.discount === null || this.props.discount === undefined) && newProps.discount) {
        }
    }

    saveDiscount = () => {
        const p = this.props;
        let discount = p.customizedDiscountModel;
        const Id = this.props.params.id || 0;
        discount.Id = Id;

        const validators = [
            [this.props.name + 'Value', discount => (discount.Value > 0), 'Value']
        ];

        if (util.validate(validators, discount, this.props.formError)) {
            this.props.saveCustomizedDiscount(discount);
        }

    }

    saveSuccess = () => {
        this.props.showSnackbar(this.state.status === "EDIT" ? LOOKUP.customizedDiscount.messages.editedMessage : LOOKUP.customizedDiscount.messages.createdMessage);
        this.redirectToDiscountList();
    }

    saveFailure = (msg) => {
        this.props.showError((
            <div>
                <p>Discount could not be saved.</p>
                <p>{msg}</p>
            </div>)
            || LOOKUP.customizedDiscount.messages.saveErrorMessage);
    }

    redirectToDiscountList() {
        this.props.navigate("/manage/discount");
    }

    render() {
        const p = this.props;
    
        return (
            <Grid headerContent={discountEditCrumb} >
                <PageHeader title="Manage Discounts" />
                <CardSimple title="Discount" className="pa-1">
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <TextInput
                                name={p.name + "Name"}
                                label={LOOKUP.customizedDiscount.name.label}
                                floatingLabelText={LOOKUP.customizedDiscount.name.label}
                                hintText={LOOKUP.customizedDiscount.name.hintText}
                                fullWidth={true}
                                maxLength={50}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <DecimalInput
                                name={`${p.name}Value`}
                                floatingLabelText={`${LOOKUP.customizedDiscount.amount.label} ${this.props.customizedDiscountType == 1 ? '(%)' : '($)'}`}
                                label={`${LOOKUP.customizedDiscount.amount.label} ${this.props.customizedDiscountType == 1 ? '(%)' : '($)'}`}
                                hintText={`${LOOKUP.customizedDiscount.amount.hintText} ${this.props.customizedDiscountType == 1 ? '(%)' : '($)'}`}
                                min={0}
                                max={100}
                                required 
                            />
                        </div>
                    </div> {/* .row */}
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <TextInput
                                name={p.name + "PromotionCode"}
                                label={LOOKUP.customizedDiscount.promotionCode.label}
                                floatingLabelText={LOOKUP.customizedDiscount.promotionCode.label}
                                hintText={LOOKUP.customizedDiscount.promotionCode.hintText}
                                fullWidth={true}
                                maxLength={50}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <DecimalInput
                                name={p.name + "MinimumAmountToApplyPromotionCode"}
                                label={LOOKUP.customizedDiscount.minimumAmountToApplyPromotionCode.label}
                                floatingLabelText={LOOKUP.customizedDiscount.minimumAmountToApplyPromotionCode.label}
                                hintText={LOOKUP.customizedDiscount.minimumAmountToApplyPromotionCode.hintText}
                                fullWidth={true}
                                min={0} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
                            <ToggleInput
                                name={p.name + "CustomizedDiscountType"}
                                label={LOOKUP.customizedDiscount.discoutType}
                                className="discount_status btnToggleLabel"
                                option1="Amount"
                                option2="Percentage"
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
                            <ToggleInput
                                name={p.name + "Status"}
                                label={LOOKUP.customizedDiscount.status}
                                className="toggle-active-inactive btnToggleLabel"
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <CheckInput
                                name={p.name + "StickyCardsDiscount"}
                                text={"Sticky Cards Discount"}
                                floatingLabelText={"Sticky Cards Discount"}
                                hintText={"Sticky Cards Discount"}
                            />
                        </div>
                    </div>
                    {p.customizedDiscountModel.StickyCardsDiscount && (
                        <div className="row">
                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                <DecimalInput
                                    name={p.name + "StickyCardPointsNeededToApply"}
                                    label={"Sticky Card Points Needed To Apply"}
                                    floatingLabelText={"Sticky Card Points Needed To Apply"}
                                    hintText={"Sticky Card Points Needed To Apply"}
                                    fullWidth={true}
                                    min={0}
                                />
                            </div>
                        </div>
                    )}
                </CardSimple>
                <PageBottomWithButtons>
                    <Button
                        name="buttonSave"
                        className="pull-right btnNewBrandPOS"
                        label={LOOKUP.customizedDiscount.controls.saveButon}
                        primary={true}
                        onTouchTap={() => this.saveDiscount()}
                    />
                    <Button
                        type="CancelButton"
                        name="buttonCancel"
                        className="pull-right btn-space btnCancelOperation"
                        label={LOOKUP.common.cancel.text}
                        onTouchTap={() => this.redirectToDiscountList()}
                    />
                </PageBottomWithButtons>
            </Grid>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        customizedDiscount: state.entity.customizedDiscount,
        customizedDiscountModel: selectDiscountModel(state, ownProps.name),
        saveSuccess: state.form[`${ownProps.name}SaveSuccess`],
        saveError: state.form[`${ownProps.name}SaveError`],
        saveTimeStamp: state.form[`${ownProps.name}SaveTimeStamp`],
        branchId: state.common.branchId,
        customizedDiscountType: state.form[ownProps.name + "CustomizedDiscountType"]
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        saveCustomizedDiscount: (model) => dispatch(saveCustomizedDiscount(model, ownProps.name)),
        getCustomizedDiscount: (id, branchId) => dispatch(getCustomizedDiscount(id, branchId, ownProps.name)),
        init: (compName) => dispatch(initializeCustomizedDiscountForm(compName)),
        formError: (name, error) => dispatch(formError(name, error)),
        clearFormErrors: () => dispatch(clearFormErrors()),
        showSnackbar: (message) => dispatch(showSnackbar(message)),
        showError: (message) => dispatch(showError(message)),
        formInput: (value, name) => dispatch(formInput(value, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(DiscountSave));